var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fields && _vm.fields.content)?_c('ctf-rich-text',{staticClass:"my-10",attrs:{"document":_vm.fields.content}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }